import { jsx as _jsx } from "react/jsx-runtime";
import { DataGrid, Typography } from '@emburse/embark-core';
import { $t, useTranslation } from '../../../hooks/useTranslation';
import { formatDateTime } from '../../../util/dateAdapter';
function SSITable({ loading, requests }) {
    useTranslation();
    return (_jsx(DataGrid, { loading: loading, autoHeight: true, pageSizeOptions: [5, 10, 20], rows: requests, sortModel: [
            {
                field: 'RequestDate',
                sort: 'desc'
            }
        ], columns: [
            {
                field: 'RequestDate',
                headerName: $t('Request Date/Time'),
                flex: 1,
                sortComparator: (v1, v2) => {
                    const lastDate = !v1 ? new Date() : new Date(v1);
                    const nextDate = !v2 ? new Date() : new Date(v2);
                    return lastDate.getTime() - nextDate.getTime();
                },
                renderCell: (cell) => _jsx(Typography, { children: formatDateTime(cell.value) })
            },
            {
                field: 'RequestorName',
                headerName: $t('Requester'),
                flex: 2,
                renderCell: (cell) => _jsx(Typography, { children: cell.value })
            },
            {
                field: 'FileName',
                headerName: $t('File Name'),
                flex: 2,
                renderCell: (cell) => _jsx(Typography, { children: cell.value })
            },
            {
                field: 'Status',
                headerName: $t('Status'),
                flex: 1,
                renderCell: (cell) => _jsx(Typography, { children: cell.value })
            }
        ] }));
}
export default SSITable;
